import Vue from 'vue'
import App from './App.vue'
import vuetify from './plugins/vuetify'
import router from './router'
import store from './store'
import VuetifyDialog from 'vuetify-dialog'
import 'vuetify-dialog/dist/vuetify-dialog.css'


// В доках пишут, что обязательно передать context и vuetify. Вроде бы работает и без него, но поверим докам
Vue.use(VuetifyDialog, {
  context: {
    vuetify
  },
  confirm: {
    actions: {
      false: 'Нет',
      true: {
        text: 'Да',
        color: 'primary'
      }
    }
  },
  error: {
    title: 'Ошибка',
    actions: {
      close: 'Закрыть'
    }
  },
  prompt: {
    actions: {
      false: 'Закрыть',
      true: {
        text: 'Да',
        color: 'primary'
      }
    }
  }
});


Vue.config.productionTip = false
new Vue({
  vuetify,
  router,
  store,
  render: h => h(App)
}).$mount('#app')
